import * as React from "react";
import { Table } from "semantic-ui-react";
import { CommonInterval } from "../../types";

interface ActivityTableRowProps {
    interval: CommonInterval;
}

export class IntervalTableRow extends React.Component<ActivityTableRowProps, {}> {
    public render() {
        const { start, end, maxStrength, stdDeviation, strain, strengthGeneration } = this.props.interval;
        const startValue = start != null ? start : 0;
        const endValue = end != null ? end : 0;
        const maxStrengthValue = maxStrength != null ? maxStrength : 0;
        const stdDeviationValue = stdDeviation != null ? stdDeviation : 0;
        const strainValue = strain != null ? strain : 0;
        const strengthGenerationValue = strengthGeneration != null ? strengthGeneration : 0;
        const duration = endValue - startValue;
        
        return (
            <Table.Row>
                <Table.Cell>{startValue.toFixed(2)}</Table.Cell>
                <Table.Cell>{duration.toFixed(2)}</Table.Cell>
                <Table.Cell>{maxStrengthValue.toFixed(1)}</Table.Cell>
                <Table.Cell>{duration > 0 ? (strainValue / duration * 60).toFixed(1) : '0.0'}</Table.Cell>
                <Table.Cell>{stdDeviationValue.toFixed(1)}</Table.Cell>
                <Table.Cell>{strainValue.toFixed(1)}</Table.Cell>
                <Table.Cell>{strengthGenerationValue.toFixed(1)}</Table.Cell>
            </Table.Row>
        );
    }
}
